import { getMenuItemUrl } from '../helpers/menu-item';
import { MenuItem } from '../interfaces/menu-item';

export const useMenuItem = (menuItem: MenuItem) => getMenuItemUrl(menuItem);
